import { Box, CardContent, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Avatar, Grid, TextField } from "@mui/material";
import { AuctionServices } from "../../../services/AllServices";
import { IMAGE_BASE } from "../../../utils/constants";
import CardLayout from "../../../layouts/CardLayout";
import React, { useEffect, useState } from "react";
import { styled } from "@mui/system";
import errorHandler from "../../../utils/errorHandler";
import { useParams } from "react-router-dom";
import { showDateTime } from "../../../utils/formatTime";

const StyledBox = styled(Box)(({ theme }) => ({
    backgroundColor: "#5e5e62",
    color: "#fff",
    padding: "20px",
    borderRadius: "10px",
    textAlign: "center",
}));

const TimerBox = styled(Box)(({ theme }) => ({
    backgroundColor: "#5e5e62",
    padding: "20px",
    borderRadius: "10px",
    textAlign: "center",
    marginTop: "20px",
}));

const BiddingHistory = () => {

    const [data, setData] = useState([]);
    const { id, auctionId, roomId } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [loaderDelay, setLoaderDelay] = useState(false);

    const fetchBidHistory = async (query) => {
        const body = {
            roomId: id,
            auctionId: auctionId,
            ticketNumber: parseInt(roomId),
        };
        try {
            setIsLoading(true);
            setLoaderDelay(false);
            const res = await AuctionServices.BiddingHistory(body);
            setTimeout(() => {
                if (res.status === 200) {
                    setData(res?.data);
                }
                setLoaderDelay(true);
            }, 500);
        } catch (err) {
            setData(err?.response?.data?.message?.data);
            errorHandler(err);
            setLoaderDelay(false);
        } finally {
            setIsLoading(false);
            setLoaderDelay(false);
        }
    };

    useEffect(() => {
        fetchBidHistory();
    }, []);

    return (
        <Box>
            <CardLayout>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        Live Auction
                    </Typography>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={12}>
                            <input
                                accept="image/*"
                                type="file"
                                style={{ display: "none" }}
                            />

                            <Box
                                mt={2}
                                className="upload-box"
                            >
                                <Avatar
                                    src={IMAGE_BASE + data?.image}
                                    alt="preview"
                                    className="avatar"
                                />
                            </Box>
                        </Grid>


                        <Grid item xs={12} md={12}>
                            <StyledBox>
                                <Typography variant="h6">{data?.winner?.username || "No bids yet"}</Typography>
                                <Typography variant="h4">${data?.winner?.bid?.toFixed(2)}</Typography>
                                {/* <Typography variant="h6">${showDateTime(data?.winner?.time)}</Typography> */}
                            </StyledBox>
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <TableContainer component={Paper} className={'tablestyle'} sx={{ backgroundColor: "#1c1c1e", color: "#fff", mt: 2 }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ color: "#fff" }}>Bid Value</TableCell>
                                            <TableCell sx={{ color: "#fff" }}>User</TableCell>
                                            <TableCell sx={{ color: "#fff" }}>Last Bid Time</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {data?.data?.length > 0 ? (
                                            data?.data.slice().reverse().map((bidData, index) => (
                                                <TableRow key={index}>
                                                    <TableCell sx={{ color: "#fff" }}>${bidData?.bid?.toFixed(2)}</TableCell>
                                                    <TableCell sx={{ color: "#fff" }}>{bidData?.username}</TableCell>
                                                    <TableCell sx={{ color: "#fff" }}>{new Date(bidData?.time).toLocaleString()}</TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell sx={{ color: "#fff" }} colSpan={3} align="center">
                                                    No bids history available
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>

                    </Grid>
                </CardContent>
            </CardLayout>
        </Box>
    );
};

export default BiddingHistory;